<template>
    <div>
        <div v-if="selected_bank">
            <h3 class="mb-0">Personal Loan Details</h3>
            <b-form role="form" class="mt-4" >
                <b-row>
                    <b-col md="8" cols="12">
                        <b-form-group label="Bank Selected">
                            <el-image style="height: 20px;" :src="selected_bank.bank_image_url" fit="contain">
                            <template #error>
                                    <div class="image-slot">
                                        <span class="d-inline-block text-truncate" style="max-width: 90px;">{{ selected_bank.bank_name }}</span>
                                    </div>
                                </template>
                            </el-image>
                        </b-form-group>
                    </b-col>
    
                    <b-col md="8" cols="12">
                        <b-form-group label="Loan Amount (RM)">
                            <b-form-input
                                v-model="form.loan_amount"
                                type="number"
                                step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Interest Rate">
                            <b-form-input
                                v-model="form.interest_per_annum"
                                type="number"
                                step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                     
                    <b-col md="8" cols="12">
                        <b-form-group label="Tenure Year">
                            <el-select v-model="form.tenure_year" placeholder="Select">
                                <el-option
                                    v-for="num in 10"
                                    :key="num"
                                    :label="num + ' Years'"
                                    :value="num"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Installment (RM)">
                            <b-form-input
                                v-model="installment"
                                type="number"
                                step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
    
                    <b-col cols="12" v-if="checkAppCode('sas')">
                        <h3 class="mb-4">Arrangement Fee</h3>
                    </b-col>
    
                    <b-col md="8" cols="10" v-if="checkAppCode('sas')">
                        <b-form-group label="Arrangement Fee Amount">
                            <b-form-input
                            v-model="form.arrangement_fee"
                            type="number"
                            step="0.01"
                              ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12" v-if="checkAppCode('sas')">
                        <b-form-group label="Arrangement Fee SST">
                            <b-form-radio-group
                                v-model="form.arrangement_fee_sst"
                                :options="SST_OPTIONS"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12" v-if="checkAppCode('sas')">
                         <b-form-group label="Total Arrangement Fee (RM)">
                            <b-form-input
                            v-model="form.arrangement_fee_amount"
                            type="text"
                            required
                            disabled
                            placeholder="0.00"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
    
                    <b-col md="8" cols="12">
                        <b-button block variant="primary" class="mb-5" @click.prevent="savePersonalLoan">Proceed</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <p class="text-center" v-else>Please select a bank.</p>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton, Image } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
import helperFunctionMixin from '@/assets/js/helperFunctionMixin.js'
import {
  calculateInstallment, 
  calculatePersonalLoanInstallment
} from '@/assets/js/calculator.js'
import {SST_OPTIONS} from '@/assets/js/options.js'

export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
        [Image.name]: Image,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
        return {
            selected_bank: null,
            form: {
                loan_amount: 0,
                interest_per_annum: '',
                tenure_year: '',
                installment: '',
                arrangement_fee: 0,
                arrangement_fee_any_amount: '',
                arrangement_fee_amount: 0,
                arrangement_fee_sst: 0,
                min_loan_amount:0,
                max_loan_amount:0
            },
            SST_OPTIONS: SST_OPTIONS,
        }
    },
    watch: {
        'current_product_data':{
            handler(newVal){
                if(this.current_product_type === 'personal_loan'){
                    if(newVal.hasOwnProperty('banks')){
                        this.selected_bank = newVal.banks[0]
                        this.form.interest_per_annum = newVal.banks[0].bank_loan_interest_rate
                        this.form.tenure_year = newVal.banks[0].bank_loan_tenure_year
                        if (!_gHlp.checkAccess(['c_customer__personal_loan_eligible'])){
                            this.form.loan_amount = newVal.banks[0].bank_max_loan_amount
                        } else {
                            this.form.loan_amount = newVal.banks[0].bank_loan_eligibility_amount
                        }
                        this.min_loan_amount = newVal.banks[0].bank_min_loan_amount
                        this.max_loan_amount = newVal.banks[0].bank_max_loan_amount
                    }
                }
            },
        },
        'form':{
            handler(newVal){
                if(newVal){ 
                    let sst_fee = parseFloat(this.form.arrangement_fee) * parseFloat(this.form.arrangement_fee_sst) / 100
                    //set total arragement fee
                    let arrangement_fee_amount = parseFloat(this.form.arrangement_fee) + parseFloat(sst_fee)
                    if(isNaN(arrangement_fee_amount)){
                        this.form.arrangement_fee_amount = 0
                    }else{
                        this.form.arrangement_fee_amount = arrangement_fee_amount
                    }
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapState(useProductStore, ['current_product_data', 'current_product_type']),
        installment:{
            get(){
                return calculatePersonalLoanInstallment(this.form.loan_amount, this.form.interest_per_annum, this.form.tenure_year)
            },
            set(val){
                this.form.installment = val
            }
        }
    },
    methods: {
        ...mapActions(useProductStore, ['createPersonalLoanProduct']),
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        async savePersonalLoan() {
            if(parseFloat(this.form.loan_amount) > parseFloat(this.max_loan_amount)){
                this.errorFunction(null, 'The maximum loan amount is RM'+ this.formatToMoney(this.max_loan_amount))
                return
            }

            if(parseFloat(this.form.loan_amount) < parseFloat(this.min_loan_amount)){
                this.errorFunction(null, 'The minimum loan amount is RM'+ this.formatToMoney(this.min_loan_amount))
                return
            }

            const personal_loan = {
                personal_loan_loan_amount: this.form.loan_amount,
                personal_loan_interest_rate: this.form.interest_per_annum,
                personal_loan_tenure_year: this.form.tenure_year,
                personal_loan_installment: this.installment,
                personal_loan_arragement_fee: this.form.arrangement_fee,
                personal_loan_arragement_sst_fee: this.form.arrangement_fee_sst,
                personal_loan_arragement_amount: this.form.arrangement_fee_amount,
            }

            useProductStore().$patch((state) => {
                state.current_product_data = { 
                    ...state.current_product_data, 
                    personal_loan: personal_loan
                }
            })

            try{
                await this.createPersonalLoanProduct()
                this.notifySuccess('<b>Draft </b> - Successfully Created.')
                this.selected_bank = null
                solutionEventBus.$emit('show-personal-loan-summary')
            }catch(e){
                this.errorFunction(null, e)
            }
        },
    }
}
</script>